import React, { Suspense, useRef } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import ScrollReveal from "./utils/ScrollReveal";
import { PersistGate } from "zustand-persist";

// Layouts
import AdminLayout from "layouts/Admin";
import { RolesProvidor } from "context/rolesContext";
import Spinner from "components/Spinner";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";

const TermsOfUse = React.lazy(() => import("views/TermsOfUse"));
const Login = React.lazy(() => import("views/Login"));
const PrivacyPolicy = React.lazy(() => import("views/PrivacyPolicy"));
const FAQ = React.lazy(() => import("views/Faq"));
const ForgetPassword = React.lazy(() => import("views/ForgetPassword"));
const TwoFactor = React.lazy(() => import("views/TwoFactor"));
const TermsOfServices = React.lazy(() => import("views/TermsOfServices"));
const AboutUs = React.lazy(() => import("views/AboutUs"));
const ResetPassword = React.lazy(() => import("views/ResetPassword"));
const LayoutDefault = React.lazy(() => import("layouts/LayoutDefault"));
// const AdminLayout = React.lazy(() => import("layouts/Admin"));

const queryClient = new QueryClient();

const TermsOfUseLayout = () => {
  return (
    <Suspense fallback={<Spinner />}>
      <TermsOfUse />
    </Suspense>
  );
};

const AdminLayoutSuspense = (props) => {
  return (
    <Suspense fallback={<Spinner />}>
      <AdminLayout {...props} />
    </Suspense>
  );
};

const LayoutDefaultSuspense = () => {
  return (
    <Suspense fallback={<Spinner />}>
      <LayoutDefault />
    </Suspense>
  );
};

const LoginLayout = () => {
  return (
    <Suspense fallback={<Spinner />}>
      <Login />
    </Suspense>
  );
};
const PrivacyPolicyLayout = () => {
  return (
    <Suspense fallback={<Spinner />}>
      <PrivacyPolicy />
    </Suspense>
  );
};
const AboutUsLayout = () => {
  return (
    <Suspense fallback={<Spinner />}>
      <AboutUs />
    </Suspense>
  );
};
const FaqLayout = () => {
  return (
    <Suspense fallback={<Spinner />}>
      <FAQ />
    </Suspense>
  );
};
const TermsOfServicesLayout = () => {
  return (
    <Suspense fallback={<Spinner />}>
      <TermsOfServices />
    </Suspense>
  );
};
const ForgetPasswordLayout = () => {
  return (
    <Suspense fallback={<Spinner />}>
      <ForgetPassword />
    </Suspense>
  );
};
const TwoFactorLayout = () => {
  return (
    <Suspense fallback={<Spinner />}>
      <TwoFactor />
    </Suspense>
  );
};
const ResetPasswordLayout = () => {
  return (
    <Suspense fallback={<Spinner />}>
      <ResetPassword />
    </Suspense>
  );
};

const App = () => {
  const childRef = useRef();

  return (
    <QueryClientProvider client={queryClient}>
      <PersistGate>
        <RolesProvidor>
          <BrowserRouter>
            <ScrollReveal
              ref={childRef}
              children={() => (
                <Switch>
                  <Route exact path="/" component={LayoutDefaultSuspense} />
                  <Route
                    exact
                    path="/privacypolicy"
                    component={PrivacyPolicyLayout}
                  />
                  <Route exact path="/aboutus" component={AboutUsLayout} />
                  <Route
                    exact
                    path="/termsofservices"
                    component={TermsOfServicesLayout}
                  />
                  <Route
                    exact
                    path="/termsofuse"
                    component={TermsOfUseLayout}
                  />
                  <Route
                    exact
                    path="/forget-password"
                    component={ForgetPasswordLayout}
                  />
                  <Route
                    exact
                    path="/reset-password"
                    component={ResetPasswordLayout}
                  />
                  <Route exact path="/two-factor" component={TwoFactorLayout} />
                  <Route exact path="/faq" component={FaqLayout} />
                  <Route exact path="/login" component={LoginLayout} />

                  <Route
                    path="/admin"
                    render={(props) => <AdminLayoutSuspense {...props} />}
                  />
                </Switch>
              )}
            />
          </BrowserRouter>
        </RolesProvidor>
      </PersistGate>
    </QueryClientProvider>
  );
};

export default App;
